module.exports = __webpack_public_path__ + "media/src/assets/Images/Tick-81f76cab5840b506a33c4df63586fd18.svg";